import { CircularProgress, Stack, Typography } from "@mui/material";
import { fromISO8601 } from "../../../utils/iso8601";
import { constructCloudflareStreamUrl } from "../utils";

import type { Asset } from "../server/digital-asset-service";
import type { FC } from "react";

export const VideoAssetPreview: FC<{ asset: Asset }> = ({ asset }) => {
  if (!asset.external_storage_id || !asset.created_at) {
    return null;
  }

  // Calculate if video processing is complete (more than 15 seconds since creation)
  const createdAt = fromISO8601(asset.created_at);
  const now = new Date();
  const timeDiffInSeconds = (now.getTime() - createdAt.getTime()) / 1000;
  const isVideoProcessingComplete = timeDiffInSeconds > 15;

  if (!isVideoProcessingComplete) {
    return (
      <Stack alignItems="center" gap={2}>
        <CircularProgress />
        <Typography variant="body2">Processing...</Typography>
      </Stack>
    );
  }

  return (
    <iframe
      src={`${constructCloudflareStreamUrl(asset.external_storage_id)}/iframe`}
      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
      allowFullScreen
      title="Video Preview"
      width="480"
      height="270"
    ></iframe>
  );
};
